import { useEffect, useState } from 'react';
import { usePreviousValue } from '../../../../hooks/usePreviousValue';
export const useTokenizerScrollState = ({
  focusedIndex,
  tokensLength,
  containerRef,
  originalTokensLength
}) => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const prevTokensLength = usePreviousValue(tokensLength) ?? 0;

  // Update scrollIndex
  useEffect(() => {
    if (focusedIndex !== undefined) {
      setScrollIndex(focusedIndex);
    }
  }, [focusedIndex]);

  // scroll to the newly added token
  useEffect(() => {
    if (focusedIndex === undefined && tokensLength > prevTokensLength) {
      setScrollIndex(tokensLength - 1);
    }
  }, [focusedIndex, prevTokensLength, tokensLength]);
  useEffect(() => {
    if (focusedIndex === undefined && scrollIndex > tokensLength - 1 && ![tokensLength, originalTokensLength].includes(0)) {
      setScrollIndex(tokensLength - 1);
    }
  }, [focusedIndex, originalTokensLength, scrollIndex, tokensLength]);

  // Scroll to the bottom when new token is added
  useEffect(() => {
    if (!containerRef.current) return;
    if (tokensLength > prevTokensLength) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [tokensLength, prevTokensLength, containerRef]);
  return {
    scrollIndex,
    setScrollIndex
  };
};
//# sourceMappingURL=useTokenizerScrollState.js.map